query SupplierAlias($id: UUID!) {
  supplierAlias(id: $id) {
    _rowTimestamp
      companyOrLastName
      firstName
      nameAlias
      _isUpdatable
      
    }
    }
  


  

